import React, { useState } from 'react';
import './BreakImage.css';
import { motion } from 'framer-motion';

// Import images
import jan20241Jpg from '../../../assets/images/jan2024-1.jpg';
import jan20241Webp from '../../../assets/images/jan2024-1.webp';
import jan20243Jpg from '../../../assets/images/jan2024-3.jpg';
import jan20243Webp from '../../../assets/images/jan2024-3.webp';
import jan20244Jpg from '../../../assets/images/jan2024-4.jpg';
import jan20244Webp from '../../../assets/images/jan2024-4.webp';
import jan20245Jpg from '../../../assets/images/jan2024-5.jpg';
import jan20245Webp from '../../../assets/images/jan2024-5.webp';

const BreakImage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      jpg: jan20241Jpg,
      webp: jan20241Webp,
      side: 'left'
    },
    {
      jpg: jan20243Jpg,
      webp: jan20243Webp,
      side: 'right'
    },
    {
      jpg: jan20244Jpg,
      webp: jan20244Webp,
      side: 'left'
    },
    {
      jpg: jan20245Jpg,
      webp: jan20245Webp,
      side: 'right'
    }
  ];

  return (
    <div className="break-image">
      {images.map((image, index) => (
        <motion.div
          key={index}
          className={`image-container ${image.side}`}
          initial={{ x: image.side === 'left' ? -100 : 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          whileHover={{ 
            scale: 1.05,
            transition: { duration: 0.2 }
          }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: index * 0.2 }}
          onClick={() => setSelectedImage(image)}
        >
          <picture>
            <source srcSet={image.webp} type="image/webp" />
            <img src={image.jpg} alt={`Scene ${index + 1}`} />
          </picture>
        </motion.div>
      ))}

      {selectedImage && (
        <motion.div 
          className="modal" 
          onClick={() => setSelectedImage(null)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div 
            className="modal-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <picture>
              <source srcSet={selectedImage.webp} type="image/webp" />
              <img src={selectedImage.jpg} alt="Enlarged view" />
            </picture>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default BreakImage;